<template>
    <div>
        <Header></Header>
        <div :style="{
            'margin-left': innerWidth > 1500 ? (innerWidth - 1500) / 2 + 'px' : '0px',
            'height': (innerHeight - 70 - 68) + 'px'
        }">
            <div class="down_app" style="height: 100%;">
                <div class="fl">
                    <img src="../../static/image/downApp/app_model.png" style="width: 50%;margin-left: 40%;margin-top: 20%;" />
                </div>
                <div class="fl" style="margin-left: 10%;">
                    <div>
                        <img src="../../static/image/downApp/title.png" style="width: 50%;margin-top: 20%;" />
                        <div style="margin-top: 15%;">
                            <div class="fl">
                                <img src="../../static/image/downApp/qr.png" style="width: 200px;;" />
                            </div>
                             <div class="fl" style="margin-left: 10%;margin-top: 5%;">
                                <img src="../../static/image/downApp/ios.png"  style="width: 200px;" /><br/>
                                <img src="../../static/image/downApp/android.png"  style="width: 200px;margin-top: 30px;" />
                             </div>
                        </div>
                    </div>
                    
                </div>


            </div>
        </div>



        <Suspension></Suspension>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from "../components/common/Header"
import Footer from "../components/common/Footer"
import Suspension from "../components/common/Suspension"


export default {
    name: "downApp",
    components: {
        Header,
        Footer,
        Suspension
    },
    data() {
        return {
            innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            innerHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        }
    }
}
</script>
<style scoped>
.down_app {
    background-image: url(../../static/image/downApp/down_app_background.png);
    background-size: cover;
    width: 1500px;
}
</style>